import { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";
import AuthSlice from "../store/Authslice";

const Logout = () => {
    const dispatch = useDispatch();
    const authValue = useSelector((store) => store.auth);
    const clickHandler = () => {
       
        localStorage.setItem("authToken", "");
        console.log(authValue.authToken)
        
	};

	return (
		<Fragment>
			<h1>Am Logout page</h1>
			<button onClick={clickHandler}>Click here to logout</button>
		</Fragment>
	);
};

export default Logout;